var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('audio',{ref:"audio",attrs:{"preload":""}},[_c('source',{attrs:{"src":"audio/20000.wav","type":"audio/mpeg"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }